import type { AgentTask } from '../types';

/** Which owner actions a task row offers. Pure, so the rule is pinned by a node test. */
export interface TaskActionAvailability {
  /** Approve and Reject (INV §1.2): only an approval-gated draft waiting on the owner. */
  canApproveOrReject: boolean;
  /** Mark reviewed (INV §1.2): a read-only audit in needs_review, or failed work not yet reviewed. */
  canMarkReviewed: boolean;
  /** Message the agent (INV §2.1): every owner state, terminal ones included (it reopens them). */
  canMessage: boolean;
}

export function taskActions(
  task: Pick<AgentTask, 'bucket' | 'state' | 'failureReviewed'>,
): TaskActionAvailability {
  return {
    canApproveOrReject: task.bucket === 'action' && task.state === 'awaiting_approval',
    canMarkReviewed:
      (task.bucket === 'audit' && task.state === 'needs_review') ||
      (task.state === 'failed' && !task.failureReviewed),
    canMessage: true,
  };
}
